"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Live;
const React = __importStar(require("react"));
const Editor_1 = __importDefault(require("./editor/Editor"));
const hooks_1 = require("./hooks");
function Live() {
    const canvasRef = React.useRef(null);
    const options = React.useMemo(() => ({
        // width: window.innerWidth,
        // height: window.innerHeight,
        width: 1024,
        height: 1024 / (window.innerWidth / window.innerHeight),
    }), []);
    const [visibleEditor, setVisibleEditor] = React.useState(false);
    const [lastCode, setLastCode] = React.useState("");
    const [synth, error, clearError, update] = (0, hooks_1.useGydra)(canvasRef, "", options);
    const debug = (0, hooks_1.useDebug)();
    const debuggerElement = React.createRef();
    React.useEffect(() => {
        if (debug && synth && debuggerElement.current) {
            synth.debugger(debuggerElement.current);
            return () => {
                synth.debugger();
            };
        }
    }, [debug, synth, debuggerElement]);
    function updateCode(newCode) {
        console.log("updateCode", newCode);
        //update(newCode)
        //setLastCode(newCode)
        synth.eval(newCode);
    }
    React.useEffect(() => {
        if (!synth)
            return;
        function setCode() {
            fetch("/live.js").then(async (res) => {
                const rawCode = await res.text();
                eval(rawCode);
                const code = window["live"];
                if (!visibleEditor && code !== lastCode) {
                    await synth.eval(code);
                    setLastCode(code);
                }
            });
        }
        setCode();
        const interval = setInterval(setCode, 1000);
        document.body.style.cursor = "none";
        return () => {
            clearInterval(interval);
            document.body.style.cursor = "auto";
        };
    }, [synth, lastCode, visibleEditor]);
    return (React.createElement(React.Fragment, null,
        React.createElement("canvas", { style: {
                width: "100%",
            }, ref: canvasRef }),
        debug && React.createElement("div", { className: "debugger", ref: debuggerElement }),
        synth && (React.createElement(Editor_1.default, { onChangeVisibility: setVisibleEditor, hide: !visibleEditor, startValue: lastCode, error: error, closeError: clearError, onRun: updateCode }))));
}
